<template>
  <div>
    <div class="mb"><div class="label">{{ $t('label.ipAddress') }}:</div> {{ status.address }}</div>
    <div class="mb"><div class="label">{{ $t('label.hostName') }}:</div> {{ status.hostName }}</div>
    <div class="mb"><div class="label">{{ $t('label.gatewayIp') }}:</div> {{ status.gatewayIp }}</div>
    <div class="mb"><div class="label">{{ $t('label.isGatewayAlive') }}:</div> {{ status.isGatewayAlive }}</div>
    <div class="mb"><div class="label">{{ $t('label.publicIp') }}:</div> {{ status.publicIp }}</div>

    <div style="float: right">
      <el-button @click="updateStatus" :disabled="loading">
        <fa-icon icon="refresh" :animated="loading"/> {{ $t('button.refresh') }}
      </el-button>
   </div>
  </div>
</template>

<script>
import { get } from 'providers/http'

export default {
  name: 'lan-status',
  props: {
  },
  data () {
    return {
      status: {
        address: null,
        hostName: null,
        gatewayIp: null,
        isGatewayAlive: null,
        publicIp: null
      },
      loading: false
    }
  },
  computed: {
  },
  methods: {
    async updateStatus () {
      this.loading = true
      this.status = await get('api/v1/status/lan')
      this.loading = false
    }
  },
  created () {
    this.updateStatus()
  }
}
</script>

<style scoped>
.label {
  display: inline-block;
  width: 50%;
}
.mb {
  margin-bottom: 5px;
}
</style>


// WEBPACK FOOTER //
// LANStatus.vue?6b0bac10